export default "__VITE_ASSET__D2NoD1qc__"